import { FC } from 'react';
import { Divider } from '@mui/material';
import { motion } from 'framer-motion';
import { useRecoilState } from 'recoil';

import './DataView.scss';
import {
  ChatCalendarTabbedSideBar,
  DataCircadian,
  DataEvent,
  DataExercise,
  DataSatisfaction,
  DataSleep,
  DataTask,
  OverviewSection,
  TabHeader,
} from '../../components';
import { sidebarOpenAtom } from '../../data-access';
import { SIDEBAR_MENU } from '../DashboardPage/SideBar/constants';
import { sidebarVariants } from '../DashboardPage/SideBar/Sidebar.variants';
import { useTranslation } from 'react-i18next';

const DataView: FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useRecoilState(sidebarOpenAtom);

  return (
    <div className="re-data-view re-data-view--new-tabs">
      <motion.aside
        className="re-data-view__chat-side-bar"
        variants={sidebarVariants}
        initial={false}
        animate={open ? 'open' : 'closed'}
        style={{ pointerEvents: open ? 'auto' : 'none' }}
      >
        <ChatCalendarTabbedSideBar collapsible showCalendarTab={false} />
      </motion.aside>
      <div className="re-data-view__main">
        <div className="re-data-view__header">
          {!open && (
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="re-data-view__open-side-bar"
              aria-label={t('data.common.openSidebar')}
            >
              <SIDEBAR_MENU.open title={t('data.common.openMenu')} />
            </button>
          )}
          <TabHeader mode="data" />
        </div>
        <Divider />
        <div className="re-data-view__content">
          <div className="re-data-view__content__top-container">
            <div className="re-data-view__section-card re-data-view__section-card--overview">
              <OverviewSection />
            </div>
            <div className="re-data-view__content__top-container__right">
              <div className="re-data-view__section-card re-data-view__section-card--sleep">
                <DataSleep />
              </div>
              <DataExercise />
            </div>
          </div>
          <div className="re-data-view__content__bottom-container">
            <div className="re-data-view__section-card re-data-view__section-card--task">
              <DataTask />
            </div>
            <div className="re-data-view__section-card re-data-view__section-card--energy">
              <DataCircadian />
            </div>
            <div className="re-data-view__content__bottom-container__right">
              <div className="re-data-view__section-card re-data-view__section-card--events">
                <DataEvent />
              </div>
              <div className="re-data-view__section-card re-data-view__section-card--satisfaction">
                <DataSatisfaction />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataView;
